// Binary Search to find the phrase index where the target ts falls in the phrase ts range
export type Phrase = {
  ts: number;
  value: string;
  ranges?: Array<PhraseRange>;
};

export type PhraseRangeType = 'punct' | 'text';

export type PhraseRange = {
  start: number;
  length: number;
  source: TranscriptElementIndex;
  type: PhraseRangeType;
};

export type TranscriptElementIndex = {
  monologue: number;
  element: number;
};

export type TranscriptionCorrection = {
  newValue: string;
  sources: TranscriptElementIndex[];
};

export type WordCorrection = {
  videoId: string;
  transcriptCorrections: TranscriptionCorrection[];
};

export type Transcript = {
  phrases: Phrase[];
  schemaVersion: string;
};

export interface TranscriptMutationResult {
  version: number;
  source_url: string;
  captions_source_url: string;
  message?: string;
}

export interface CorrectionResult {
  updateVideoTranscript: TranscriptMutationResult;
}

export interface RevertAllResult extends TranscriptMutationResult {
  revertAllTranscriptCorrections: TranscriptMutationResult;
}

export const findPhraseIndex = (target: number, phrases: Phrase[]): number => {
  const len = phrases.length;

  if (target >= phrases[phrases.length - 1].ts) {
    return phrases.length - 1;
  }

  let low = 0;
  let high = len - 1;

  while (low <= high) {
    const mid = (low + (high - low) / 2) | 0;

    if (phrases[mid].ts < target) {
      low = mid + 1;
    } else if (phrases[mid].ts > target) {
      high = mid - 1;
    } else {
      return mid;
    }
  }

  if (high < 0) {
    return 0;
  } else if (low > len - 1) {
    return len;
  }

  return low < high ? low : high;
};
